var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.585 12.693C2.11069 12.704 1.65132 12.5267 1.30742 12.1998C0.963521 11.873 0.763095 11.4232 0.75 10.949V2.49495C0.763354 2.02087 0.963894 1.57136 1.30777 1.24473C1.65164 0.918097 2.11086 0.740923 2.585 0.75195H13.911C14.3853 0.740927 14.8447 0.918238 15.1886 1.24508C15.5325 1.57193 15.7329 2.02169 15.746 2.49595V10.949C15.7352 11.3835 15.566 11.7992 15.2703 12.1178C14.9745 12.4364 14.5726 12.6359 14.14 12.679C14.0993 12.6877 14.0577 12.6921 14.016 12.692L2.585 12.693Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60352 8.26099H12.8925",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60352 10.2959H12.8925",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.744 3.14697H3.75195V6.22197H12.744V3.14697Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.bb7ff47abd50cfbb9aeba4b897b66a85.svg";
export { ForwardRef as ReactComponent };